import { useRouter } from 'next/router';
import { HeaderFunnel } from '@ferreri/prever-component-lib';

import LocationBase from './LocationBase';

const LocationEdit = () => {
  const router = useRouter();

  return (
    <LocationBase>
      <HeaderFunnel onClickArrow={router.back}>Localização</HeaderFunnel>
    </LocationBase>
  );
};

export default LocationEdit;
